import { apiUrl } from "helpers/constants/config.constants"
import { httpPost } from "./http.service"

export interface FileObject {
  fileId: string
  projectId: string
  identifier: string
  s3Url: string
  type: string
  createdAt: Date
  createdBy: string
  localPath: string
  updatedBy: string
  updatedAt: Date
  deletedBy: string
  deletedAt: Date
}

export const doFileUpload = (
  file_name: string,
  file: string,
  identifier?: string
): Promise<FileObject> => {
  return new Promise((resolve, reject) => {
    const params = {
      file_name, file
    }

    const headers = {
      identifier
    }
    httpPost(apiUrl.file.upload, params, headers).then((resp: any) => {
      const response = resp
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  })
}